import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Reportes } from './Pages';
import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';

// jspdf-autotable 5 ya no se registra solo en jsPDF: sin esto doc.autoTable() no existe y todos los PDF fallan
applyPlugin(jsPDF);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
